import { inputEmits as We, inputProps as je } from "./index649.js";
import { defineComponent as Ge, useAttrs as Ye, useSlots as qe, computed as u, shallowRef as j, ref as G, watch as Y, nextTick as I, onMounted as Je, toRef as Qe, openBlock as i, createElementBlock as c, normalizeStyle as ye, normalizeClass as d, unref as t, createCommentVNode as r, Fragment as q, renderSlot as A, createElementVNode as C, createBlock as v, withCtx as z, resolveDynamicComponent as V, mergeProps as xe, withModifiers as J, toDisplayString as H } from "vue";
import { useResizeObserver as Xe } from "./index562.js";
import { ElIcon as N } from "./index538.js";
import { View as Ze, Hide as _e } from "./index537.js";
import { looseToNumber as he, calcTextareaHeight as we } from "./index743.js";
import { useAttrs as et } from "./index698.js";
import { useFormSize as tt, useFormDisabled as ot } from "./index586.js";
import { useFocusController as at } from "./index587.js";
import { useFormItem as nt, useFormItemInputId as lt } from "./index585.js";
import { ValidateComponentsMap as st } from "./index606.js";
import { useComposition as it } from "./index710.js";
import { UPDATE_MODEL_EVENT as Q, CHANGE_EVENT as be, INPUT_EVENT as X } from "./index584.js";
import { useCursor as rt } from "./index709.js";
import { useNamespace as ge } from "./index559.js";
import { debugWarn as Z } from "./index588.js";
import { NOOP as _, isObject as Ie } from "./index575.js";
import ut from "./index567.js";
import { isClient as dt } from "./index599.js";
const mt = ["id", "name", "minlength", "maxlength", "type", "disabled", "readonly", "autocomplete", "tabindex", "aria-label", "placeholder", "form", "autofocus", "role", "inputmode"], ft = ["id", "name", "minlength", "maxlength", "tabindex", "disabled", "readonly", "autocomplete", "aria-label", "placeholder", "form", "autofocus", "rows", "role"], Ce = "ElInput";
var Tt = /* @__PURE__ */ Ge({
  name: Ce,
  inheritAttrs: !1,
  __name: "input",
  props: je,
  emits: We,
  setup(n, { expose: ke, emit: Ee }) {
    const o = n, m = Ee, ee = Ye(), te = et(), k = qe(), Me = u(() => [
      o.type === "textarea" ? ne.b() : l.b(),
      l.m(ze.value),
      l.is("disabled", x.value),
      l.is("exceed", Re.value),
      {
        [l.b("group")]: k.prepend || k.append,
        [l.m("prefix")]: k.prefix || o.prefixIcon,
        [l.m("suffix")]: k.suffix || o.suffixIcon || o.clearable || o.showPassword,
        [l.bm("suffix", "password-clear")]: $.value && K.value,
        [l.b("hidden")]: o.type === "hidden"
      },
      ee.class
    ]), Se = u(() => [
      l.e("wrapper"),
      l.is("focus", D.value)
    ]), { form: oe, formItem: p } = nt(), { inputId: ae } = lt(o, {
      formItemContext: p
    }), ze = tt(), x = ot(), l = ge("input"), ne = ge("textarea"), P = j(), y = j(), B = G(!1), R = G(!1), le = G(), T = j(o.inputStyle), f = u(() => P.value || y.value), { wrapperRef: Ve, isFocused: D, handleFocus: se, handleBlur: ie } = at(
      f,
      {
        disabled: x,
        afterBlur() {
          var e;
          o.validateEvent && ((e = p?.validate) == null || e.call(p, "blur").catch((a) => Z(a)));
        }
      }
    ), re = u(() => {
      var e;
      return (e = oe?.statusIcon) != null ? e : !1;
    }), E = u(() => p?.validateState || ""), ue = u(
      () => E.value && st[E.value]
    ), Ne = u(
      () => R.value ? Ze : _e
    ), Pe = u(() => [
      ee.style
    ]), de = u(() => [
      o.inputStyle,
      T.value,
      { resize: o.resize }
    ]), h = u(
      () => ut(o.modelValue) ? "" : String(o.modelValue)
    ), $ = u(
      () => o.clearable && !x.value && !o.readonly && !!h.value && (D.value || B.value)
    ), K = u(
      () => o.showPassword && !x.value && !!h.value
    ), w = u(
      () => o.showWordLimit && !!o.maxlength && (o.type === "text" || o.type === "textarea") && !x.value && !o.readonly && !o.showPassword
    ), U = u(() => h.value.length), Re = u(
      () => (
        // show exceed style if length of initial value greater then maxlength
        !!w.value && U.value > Number(o.maxlength)
      )
    ), Te = u(
      () => !!k.suffix || !!o.suffixIcon || $.value || o.showPassword || w.value || !!E.value && re.value
    ), $e = u(
      () => !!Object.keys(o.modelModifiers).length
    ), [Fe, Oe] = rt(P);
    Xe(y, (e) => {
      if (Le(), !w.value || o.resize !== "both" && o.resize !== "horizontal")
        return;
      const a = e[0], { width: s } = a.contentRect;
      le.value = {
        /** right: 100% - width + padding(22) - right(10) */
        right: `calc(100% - ${s + 22 - 10}px)`
      };
    });
    const M = () => {
      const { type: e, autosize: a } = o;
      if (!(!dt || e !== "textarea" || !y.value))
        if (a) {
          const s = Ie(a) ? a.minRows : void 0, g = Ie(a) ? a.maxRows : void 0, S = we(y.value, s, g);
          T.value = {
            overflowY: "hidden",
            ...S
          }, I(() => {
            y.value.offsetHeight, T.value = S;
          });
        } else
          T.value = {
            minHeight: we(y.value).minHeight
          };
    }, Le = ((e) => {
      let a = !1;
      return () => {
        var s;
        if (a || !o.autosize) return;
        ((s = y.value) == null ? void 0 : s.offsetParent) === null || (setTimeout(e), a = !0);
      };
    })(M), b = () => {
      const e = f.value, a = o.formatter ? o.formatter(h.value) : h.value;
      !e || e.value === a || o.type === "file" || (e.value = a);
    }, me = (e) => {
      const { trim: a, number: s } = o.modelModifiers;
      return a && (e = e.trim()), s && (e = `${he(e)}`), o.formatter && o.parser && (e = o.parser(e)), e;
    }, W = async (e) => {
      if (ce.value) return;
      const { lazy: a } = o.modelModifiers;
      let { value: s } = e.target;
      if (a) {
        m(X, s);
        return;
      }
      if (s = me(s), String(s) === h.value) {
        o.formatter && b();
        return;
      }
      Fe(), m(Q, s), m(X, s), await I(), (o.formatter && o.parser || !$e.value) && b(), Oe();
    }, fe = async (e) => {
      let { value: a } = e.target;
      a = me(a), o.modelModifiers.lazy && m(Q, a), m(be, a, e), await I(), b();
    }, {
      isComposing: ce,
      handleCompositionStart: F,
      handleCompositionUpdate: O,
      handleCompositionEnd: L
    } = it({ emit: m, afterComposition: W }), Ae = () => {
      R.value = !R.value;
    }, He = () => {
      var e;
      return (e = f.value) == null ? void 0 : e.focus();
    }, Be = () => {
      var e;
      return (e = f.value) == null ? void 0 : e.blur();
    }, De = (e) => {
      B.value = !1, m("mouseleave", e);
    }, Ke = (e) => {
      B.value = !0, m("mouseenter", e);
    }, ve = (e) => {
      m("keydown", e);
    }, Ue = () => {
      var e;
      (e = f.value) == null || e.select();
    }, pe = () => {
      m(Q, ""), m(be, ""), m("clear"), m(X, "");
    };
    return Y(
      () => o.modelValue,
      () => {
        var e;
        I(() => M()), o.validateEvent && ((e = p?.validate) == null || e.call(p, "change").catch((a) => Z(a)));
      }
    ), Y(h, (e) => {
      if (!f.value)
        return;
      const { trim: a, number: s } = o.modelModifiers, g = f.value.value, S = (s || o.type === "number") && !/^0\d/.test(g) ? `${he(g)}` : g;
      S !== e && (document.activeElement === f.value && f.value.type !== "range" && a && S.trim() === e || b());
    }), Y(
      () => o.type,
      async () => {
        await I(), b(), M();
      }
    ), Je(() => {
      !o.formatter && o.parser && Z(
        Ce,
        "If you set the parser, you also need to set the formatter."
      ), b(), I(M);
    }), ke({
      /** @description HTML input element */
      input: P,
      /** @description HTML textarea element */
      textarea: y,
      /** @description HTML element, input or textarea */
      ref: f,
      /** @description style of textarea. */
      textareaStyle: de,
      /** @description from props (used on unit test) */
      autosize: Qe(o, "autosize"),
      /** @description is input composing */
      isComposing: ce,
      /** @description HTML input element native method */
      focus: He,
      /** @description HTML input element native method */
      blur: Be,
      /** @description HTML input element native method */
      select: Ue,
      /** @description clear input value */
      clear: pe,
      /** @description resize textarea. */
      resizeTextarea: M
    }), (e, a) => (i(), c(
      "div",
      {
        class: d([
          Me.value,
          {
            [t(l).bm("group", "append")]: e.$slots.append,
            [t(l).bm("group", "prepend")]: e.$slots.prepend
          }
        ]),
        style: ye(Pe.value),
        onMouseenter: Ke,
        onMouseleave: De
      },
      [
        r(" input "),
        n.type !== "textarea" ? (i(), c(
          q,
          { key: 0 },
          [
            r(" prepend slot "),
            e.$slots.prepend ? (i(), c(
              "div",
              {
                key: 0,
                class: d(t(l).be("group", "prepend"))
              },
              [
                A(e.$slots, "prepend")
              ],
              2
              /* CLASS */
            )) : r("v-if", !0),
            C(
              "div",
              {
                ref_key: "wrapperRef",
                ref: Ve,
                class: d(Se.value)
              },
              [
                r(" prefix slot "),
                e.$slots.prefix || n.prefixIcon ? (i(), c(
                  "span",
                  {
                    key: 0,
                    class: d(t(l).e("prefix"))
                  },
                  [
                    C(
                      "span",
                      {
                        class: d(t(l).e("prefix-inner"))
                      },
                      [
                        A(e.$slots, "prefix"),
                        n.prefixIcon ? (i(), v(t(N), {
                          key: 0,
                          class: d(t(l).e("icon"))
                        }, {
                          default: z(() => [
                            (i(), v(V(n.prefixIcon)))
                          ]),
                          _: 1
                          /* STABLE */
                        }, 8, ["class"])) : r("v-if", !0)
                      ],
                      2
                      /* CLASS */
                    )
                  ],
                  2
                  /* CLASS */
                )) : r("v-if", !0),
                C("input", xe({
                  id: t(ae),
                  ref_key: "input",
                  ref: P,
                  class: t(l).e("inner")
                }, t(te), {
                  name: n.name,
                  minlength: n.minlength,
                  maxlength: n.maxlength,
                  type: n.showPassword ? R.value ? "text" : "password" : n.type,
                  disabled: t(x),
                  readonly: n.readonly,
                  autocomplete: n.autocomplete,
                  tabindex: n.tabindex,
                  "aria-label": n.ariaLabel,
                  placeholder: n.placeholder,
                  style: n.inputStyle,
                  form: n.form,
                  autofocus: n.autofocus,
                  role: n.containerRole,
                  inputmode: n.inputmode,
                  onCompositionstart: a[0] || (a[0] = //@ts-ignore
                  (...s) => t(F) && t(F)(...s)),
                  onCompositionupdate: a[1] || (a[1] = //@ts-ignore
                  (...s) => t(O) && t(O)(...s)),
                  onCompositionend: a[2] || (a[2] = //@ts-ignore
                  (...s) => t(L) && t(L)(...s)),
                  onInput: W,
                  onChange: fe,
                  onKeydown: ve
                }), null, 16, mt),
                r(" suffix slot "),
                Te.value ? (i(), c(
                  "span",
                  {
                    key: 1,
                    class: d(t(l).e("suffix"))
                  },
                  [
                    C(
                      "span",
                      {
                        class: d(t(l).e("suffix-inner"))
                      },
                      [
                        !$.value || !K.value || !w.value ? (i(), c(
                          q,
                          { key: 0 },
                          [
                            A(e.$slots, "suffix"),
                            n.suffixIcon ? (i(), v(t(N), {
                              key: 0,
                              class: d(t(l).e("icon"))
                            }, {
                              default: z(() => [
                                (i(), v(V(n.suffixIcon)))
                              ]),
                              _: 1
                              /* STABLE */
                            }, 8, ["class"])) : r("v-if", !0)
                          ],
                          64
                          /* STABLE_FRAGMENT */
                        )) : r("v-if", !0),
                        $.value ? (i(), v(t(N), {
                          key: 1,
                          class: d([t(l).e("icon"), t(l).e("clear")]),
                          onMousedown: J(t(_), ["prevent"]),
                          onClick: pe
                        }, {
                          default: z(() => [
                            (i(), v(V(n.clearIcon)))
                          ]),
                          _: 1
                          /* STABLE */
                        }, 8, ["class", "onMousedown"])) : r("v-if", !0),
                        K.value ? (i(), v(t(N), {
                          key: 2,
                          class: d([t(l).e("icon"), t(l).e("password")]),
                          onClick: Ae,
                          onMousedown: J(t(_), ["prevent"]),
                          onMouseup: J(t(_), ["prevent"])
                        }, {
                          default: z(() => [
                            (i(), v(V(Ne.value)))
                          ]),
                          _: 1
                          /* STABLE */
                        }, 8, ["class", "onMousedown", "onMouseup"])) : r("v-if", !0),
                        w.value ? (i(), c(
                          "span",
                          {
                            key: 3,
                            class: d([
                              t(l).e("count"),
                              t(l).is("outside", n.wordLimitPosition === "outside")
                            ])
                          },
                          [
                            C(
                              "span",
                              {
                                class: d(t(l).e("count-inner"))
                              },
                              H(U.value) + " / " + H(n.maxlength),
                              3
                              /* TEXT, CLASS */
                            )
                          ],
                          2
                          /* CLASS */
                        )) : r("v-if", !0),
                        E.value && ue.value && re.value ? (i(), v(t(N), {
                          key: 4,
                          class: d([
                            t(l).e("icon"),
                            t(l).e("validateIcon"),
                            t(l).is("loading", E.value === "validating")
                          ])
                        }, {
                          default: z(() => [
                            (i(), v(V(ue.value)))
                          ]),
                          _: 1
                          /* STABLE */
                        }, 8, ["class"])) : r("v-if", !0)
                      ],
                      2
                      /* CLASS */
                    )
                  ],
                  2
                  /* CLASS */
                )) : r("v-if", !0)
              ],
              2
              /* CLASS */
            ),
            r(" append slot "),
            e.$slots.append ? (i(), c(
              "div",
              {
                key: 1,
                class: d(t(l).be("group", "append"))
              },
              [
                A(e.$slots, "append")
              ],
              2
              /* CLASS */
            )) : r("v-if", !0)
          ],
          64
          /* STABLE_FRAGMENT */
        )) : (i(), c(
          q,
          { key: 1 },
          [
            r(" textarea "),
            C("textarea", xe({
              id: t(ae),
              ref_key: "textarea",
              ref: y,
              class: [t(ne).e("inner"), t(l).is("focus", t(D))]
            }, t(te), {
              name: n.name,
              minlength: n.minlength,
              maxlength: n.maxlength,
              tabindex: n.tabindex,
              disabled: t(x),
              readonly: n.readonly,
              autocomplete: n.autocomplete,
              style: de.value,
              "aria-label": n.ariaLabel,
              placeholder: n.placeholder,
              form: n.form,
              autofocus: n.autofocus,
              rows: n.rows,
              role: n.containerRole,
              onCompositionstart: a[3] || (a[3] = //@ts-ignore
              (...s) => t(F) && t(F)(...s)),
              onCompositionupdate: a[4] || (a[4] = //@ts-ignore
              (...s) => t(O) && t(O)(...s)),
              onCompositionend: a[5] || (a[5] = //@ts-ignore
              (...s) => t(L) && t(L)(...s)),
              onInput: W,
              onFocus: a[6] || (a[6] = //@ts-ignore
              (...s) => t(se) && t(se)(...s)),
              onBlur: a[7] || (a[7] = //@ts-ignore
              (...s) => t(ie) && t(ie)(...s)),
              onChange: fe,
              onKeydown: ve
            }), null, 16, ft),
            w.value ? (i(), c(
              "span",
              {
                key: 0,
                style: ye(le.value),
                class: d([
                  t(l).e("count"),
                  t(l).is("outside", n.wordLimitPosition === "outside")
                ])
              },
              H(U.value) + " / " + H(n.maxlength),
              7
              /* TEXT, CLASS, STYLE */
            )) : r("v-if", !0)
          ],
          64
          /* STABLE_FRAGMENT */
        ))
      ],
      38
      /* CLASS, STYLE, NEED_HYDRATION */
    ));
  }
});
export {
  Tt as default
};
